function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import AccordionSpot from './../react-accordion-spot';
var AccordionSpotTabs = /*#__PURE__*/function (_AccordionSpot) {
  function AccordionSpotTabs(props) {
    var _this;
    _classCallCheck(this, AccordionSpotTabs);
    _this = _callSuper(this, AccordionSpotTabs, [props]);
    _this.renderHeadlineAsPartOfTitle = false;
    return _this;
  }
  _inherits(AccordionSpotTabs, _AccordionSpot);
  return _createClass(AccordionSpotTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "accordion-spot-tabs"
      }, this.props.settings.elements.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "accordion-element-title-".concat(index),
          className: "accordion-spot-tab ".concat(_this2.state.expandedElements.indexOf(index) !== -1 ? 'active' : 'passive'),
          onClick: function onClick(event) {
            _this2.onElementTitleClick(event, index);
          },
          onKeyPress: function onKeyPress(event) {
            _this2.onElementTitleClick(event, _this2.onExpandAllClick, index);
          },
          role: "button",
          tabIndex: index + 1
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-tab__title"
        }, element.title), _this2.renderHeadlineAsPartOfTitle && _this2.hasValue('header', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-tab__header"
        }, element.header));
      })), this.props.settings.elements.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "accordion-element-".concat(index),
          className: "accordion-spot-element ".concat(_this2.state.expandedElements.indexOf(index) !== -1 ? 'expand' : 'shrink'),
          "data-index": index + 1,
          onClick: _this2.state.expandedElements.indexOf(index) === -1 ? function (event) {
            _this2.onElementTitleClick(event, index);
          } : null
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__content"
        }, !_this2.renderHeadlineAsPartOfTitle && _this2.hasValue('header', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__header"
        }, element.header), _this2.hasValue('body', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__body",
          dangerouslySetInnerHTML: {
            __html: element.body
          }
        })));
      }));
    }
  }]);
}(AccordionSpot);
AccordionSpotTabs.propTypes = {
  settings: PropTypes.shape({
    mobileBackgroundImage: PropTypes.string,
    desktopBackgroundImage: PropTypes.string,
    expandAllLabel: PropTypes.string,
    shrinkAllLabel: PropTypes.string,
    allowMultipleItemsExpanded: PropTypes.bool,
    expandItemOnLoad: PropTypes.number,
    expandAllOnLoad: PropTypes.bool,
    elements: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      header: PropTypes.string,
      body: PropTypes.string
    }))
  }),
  resolveDesktop: PropTypes.func.isRequired
};
AccordionSpotTabs.defaultProps = {
  settings: {
    mobileBackgroundImage: '',
    desktopBbackgroundImage: '',
    expandAllLabel: '',
    shrinkAllLabel: '',
    allowMultipleItemsExpanded: false,
    expandItemOnLoad: 0,
    expandAllOnLoad: false,
    elements: []
  }
};
export default AccordionSpotTabs;